import React from "react";
import AnnexNavItem from "./AnnexNavItem";
import { withStyles } from "@material-ui/styles";
import styleConstants from "../../../styleConstants";

const styles = {
  sectionHeading: {
    fontSize: "1.125rem",
    fontWeight: styleConstants.fontWeights.book,
    color: styleConstants.colors.themeBlue,
    marginTop: "2rem"
  },
  linkTitle: {
    fontSize: "0.875rem",
    fontWeight: styleConstants.fontWeights.bold,
    marginTop: "0.5rem"
  },
  linkSubtitle: {
    fontSize: "0.875rem",
    fontWeight: styleConstants.fontWeights.book,
    fontStyle: "italic",
    marginBottom: "0.5rem"
  }
};

const AnnexNav = props => (
  <div className={props.classes.container}>
    <h3 className={props.classes.sectionHeading}>Users</h3>

    <AnnexNavItem linkTo="tableA1">
      <h4 className={props.classes.linkTitle}>
        Users of Contraception by Sector, 2018
      </h4>

      <h4 className={props.classes.linkSubtitle}>Segmented by Method</h4>
    </AnnexNavItem>

    <AnnexNavItem linkTo="tableA2">
      <h4 className={props.classes.linkTitle}>
        User Method Mix and Method Share by Sector, 2018
      </h4>
      <h4 className={props.classes.linkSubtitle}>Segmented by Method</h4>
    </AnnexNavItem>

    <AnnexNavItem linkTo="tableA3">
      <h4 className={props.classes.linkTitle}>
        Change in Users, 2020&ndash;2030
      </h4>
      <h4 className={props.classes.linkSubtitle}>Segmented by Method</h4>
    </AnnexNavItem>

    <h3 className={props.classes.sectionHeading}>Cost</h3>
    <AnnexNavItem linkTo="tableA4">
      <h4 className={props.classes.linkTitle}>
        Cost of Contraception by Sector, 2018
      </h4>
      <h4 className={props.classes.linkSubtitle}>Segmented by Method</h4>
    </AnnexNavItem>

    <AnnexNavItem linkTo="tableA5">
      <h4 className={props.classes.linkTitle}>
        Cost Method Mix and Method Share by Sector, 2018
      </h4>
      <h4 className={props.classes.linkSubtitle}>Segmented by Method</h4>
    </AnnexNavItem>

    <AnnexNavItem linkTo="tableA6">
      <h4 className={props.classes.linkTitle}>
        Change in Costs, 2020&ndash;2030
      </h4>
      <h4 className={props.classes.linkSubtitle}>Segmented by Method</h4>
    </AnnexNavItem>

    <h3 className={props.classes.sectionHeading}>Quantity</h3>
    <AnnexNavItem linkTo="tableA7">
      <h4 className={props.classes.linkTitle}>
        Quantity of Contraception by Sector, 2018
      </h4>
      <h4 className={props.classes.linkSubtitle}>Segmented by Method</h4>
    </AnnexNavItem>

    <AnnexNavItem linkTo="tableA8">
      <h4 className={props.classes.linkTitle}>
        Quantity Method Share by Sector, 2018
      </h4>
      <h4 className={props.classes.linkSubtitle}>Segmented by Method</h4>
    </AnnexNavItem>

    <AnnexNavItem linkTo="tableA9">
      <h4 className={props.classes.linkTitle}>
        Change in Quantities, 2020&ndash;2030
      </h4>
      <h4 className={props.classes.linkSubtitle}>Segmented by Method</h4>
    </AnnexNavItem>
  </div>
);

export default withStyles(styles)(AnnexNav);
